import React from 'react';
import { useCart } from '../context/CartContext';

export default function SeniorModeToggle() {
  const { seniorMode, setSeniorMode } = useCart();

  return (
    <button
      className="btn btn-ghost"
      style={{
        padding: '6px 12px',
        borderRadius: 'var(--radius-full)',
        fontSize: 12,
        fontWeight: 600,
        gap: 4,
        background: seniorMode ? 'var(--primary)' : 'var(--border)',
        color: seniorMode ? '#fff' : 'var(--text-tertiary)',
        transition: 'all 0.15s ease',
      }}
      onClick={() => setSeniorMode(!seniorMode)}
      title={seniorMode ? '일반 모드로 전환' : '큰 글씨 모드로 전환'}
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3" />
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      </svg>
      {seniorMode ? '작게보기' : '크게보기'}
    </button>
  );
}
